import { useNavigate } from "react-router-dom";
import { PackagePlus, PackageCheck, Scissors, Shirt, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const BTN = [
  {
    id: "pengambilan", label: "PENGAMBILAN", desc: "Catat jahitan keluar beserta bon alat jahit untuk pengepul.",
    icon: PackagePlus, path: "/operasional-jahitan/pengambilan",
    tone: "bg-[#0071E3]", border: "border-[#0071E3]/60", ring: "hover:border-[#0071E3]", glow: "group-hover:shadow-[#0071E3]/25",
  },
  {
    id: "setoran", label: "SETORAN", desc: "Terima setoran jahitan, hitung barang bagus, dan catat rijek.",
    icon: PackageCheck, path: "/operasional-jahitan/setoran",
    tone: "bg-emerald-600", border: "border-emerald-500/60", ring: "hover:border-emerald-500", glow: "group-hover:shadow-emerald-500/25",
  },
  {
    id: "rijek", label: "RIJEK", desc: "Catat rijek susulan, kirim ke perbaikan, dan terima hasil perbaikan.",
    icon: Scissors, path: "/operasional-jahitan/rijek",
    tone: "bg-orange-600", border: "border-orange-500/60", ring: "hover:border-orange-500", glow: "group-hover:shadow-orange-500/25",
  },
  {
    id: "contoh", label: "CONTOH / SAMPEL", desc: "Catat barang contoh yang dibawa pengepul (nama barang manual).",
    icon: Shirt, path: "/operasional-jahitan/contoh",
    tone: "bg-violet-600", border: "border-violet-500/60", ring: "hover:border-violet-500", glow: "group-hover:shadow-violet-500/25",
  },
];

export default function OperasionalHome() {
  const nav = useNavigate();
  const { user } = useAuth();
  const today = new Intl.DateTimeFormat("id-ID", { timeZone: "Asia/Makassar", dateStyle: "full" }).format(new Date());
  return (
    <div className="w-full" data-testid="op-home">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">MODUL OPERASIONAL JAHITAN</h1>
        <p className="text-sm text-slate-500 mt-1">Halo, {user?.name || user?.username} · {today} · WITA</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {BTN.map((b) => {
          const Icon = b.icon;
          return (
            <button
              key={b.id}
              onClick={() => nav(b.path)}
              data-testid={`op-btn-${b.id}`}
              className={`group relative flex flex-col justify-between overflow-hidden bg-white rounded-2xl border-2 ${b.border} p-6 text-left min-h-[180px] shadow-[0_4px_20px_-6px_rgba(15,23,42,0.18)] transition-all duration-200 hover:-translate-y-1 hover:shadow-2xl ${b.ring} ${b.glow}`}
            >
              <div className="flex items-start justify-between">
                <div className={`w-14 h-14 rounded-2xl ${b.tone} text-white flex items-center justify-center shadow-md transition-transform duration-200 group-hover:scale-105`}>
                  <Icon className="w-7 h-7" />
                </div>
                <ArrowRight className="w-5 h-5 text-slate-300 transition-all duration-200 group-hover:text-slate-500 group-hover:translate-x-1" />
              </div>
              <div className="mt-5">
                <div className="text-lg font-bold text-slate-900 tracking-wide">{b.label}</div>
                <div className="text-sm text-slate-500 mt-1.5 leading-relaxed">{b.desc}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
